const pubsub = require('events/pubsub');
const model = require('model/model');

module.exports = {
	data() {
		return {
			navKey: 'contentSection',
			articleList: []
		};
	},
	computed: {
		articleMap() {
			const article = this.article;
			let map = null;

			if (article && article.articles && !article.sr) {
				map = article.articles;
			}

			return map;
		},
		supplementalTexts() {
			const article = this.article;
			let texts = null;

			if (article && article.supplemental_texts) {
				texts = {};
				if (article.supplemental_texts.challenge) {
					texts = Object.assign({}, texts, article.supplemental_texts.challenge);
				}
				if (article.supplemental_texts.support) {
					texts = Object.assign({}, texts, article.supplemental_texts.support);
				}
			}

			return texts;
		},
		selectedArticle() {
			const article = this.article;
			const articleMap = this.articleMap;
			const articleList = this.articleList;
			const supplementalTexts = this.supplementalTexts;

			let selectedArticle = null;

			if (article && articleList && articleList.length > 0) {
				const key = this[this.navKey];
				selectedArticle = key ? articleMap[key] : articleList[0];
				if (!selectedArticle && supplementalTexts && supplementalTexts[key]) {
					selectedArticle = supplementalTexts[key];
				}
			} else {
				selectedArticle = article;
			}
			return selectedArticle;
		}
	},
	methods: {
		onArticleSelect(pid) {
			model.set(this.navKey, pid);
		},
		setArticleList() {
			const article = this.article;

			if (article && article.articleList && !article.sr) {
				this.articleList = article.articleList;
			}
		}
	},
	created() {
		this.setArticleList();
	},
	watch: {
		article: {
			handler() {
				this.setArticleList();

				const key = model.get(this.navKey);
				const articleList = this.articleList;
				if (!key && articleList && articleList.length > 0) {
					model.set(this.navKey, articleList[0].uuid);
				}
			},
			immediate: true
		},
		selectedArticle(selectedArticle) {
			if (selectedArticle && selectedArticle !== this.article) {
				pubsub.publish('article-selected', selectedArticle);
			}
		}
	}
};
